<template>
  <bg-style
    class="activity-widget"
    :class="$store.getters.isMobile ? 'activity_content_mobile relative' : 'activity_content_desk relative'"
    :bg="model.background"
    :mobile-bg="model.mobileBackground"
  >
    <module-block>
      <div v-if="model.titleVisible" class="activity-widget__title items-center relative" :class="{ 'flex': hasHelpIcon }">
        <rich-text
          v-model="model.title"
          :editing="editing"
          :stroke.sync="model.titleStroke"
          :disabled="!editing"
          placement="top"
          theme="snow"
          :force-wrap="hasHelpIcon"
        />
<!--        <img v-if="hasHelpIcon" class="cursor-pointer ml-5 help-icon" :src="model.helpIcon.backgroundImage" alt="" @click="handleShowRuleModal">-->
      </div>
      <row-content v-if="model.layout === AccumulationLayoutEnum.Row" :model="model" :type="AccumulationLayoutEnum.Row" :editing="editing" :is-mobile="$store.getters.isMobile" @show-detail="onItemClick" />
      <col-content v-else-if="model.layout === AccumulationLayoutEnum.Col" :model="model" :editing="editing" :type="AccumulationLayoutEnum.Col" :is-mobile="$store.getters.isMobile" @show-detail="onItemClick" />
      <div class="activity-widget__describe">
        <rich-text
          v-if="model.subtitleVisible"
          v-model="model.subtitle"
          :stroke.sync="model.subTitleStroke"
          :editing="editing"
          :disabled="!editing"
          placement="top"
          theme="snow"
        />
      </div>
    </module-block>
    <info-detail ref="info" :data="currentRow" :is-mobile="$store.getters.isMobile" />
    <el-dialog :width="ruleDialogWidth" :visible.sync="ruleVisible" :modal="!editing" class="accumulation-rule-dialog" :class="{ 'is-edit': editing, 'is-mobile': $store.getters.isMobile}">
      <div class="accumulation-rule-dialog__content">
        <rich-text v-model="model.ruleTitle" :editing="editing" :disabled="!editing" placement="top" theme="snow" />
        <rich-text v-model="model.ruleDescribe" class="mt-5" :editing="editing" :disabled="!editing" />
      </div>
    </el-dialog>
  </bg-style>
</template>

<script>
import { Dialog } from 'element-ui'
import RowContent from './rowContent.vue'
import ColContent from './colContent.vue'
import InfoDetail from './info.vue'
import richText from '~/components/richText'
import { AccumulationLayoutEnum } from '~/enums/data'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

export default {
  name: 'ActivityWidgetEdit',
  components: {
    [Dialog.name]: Dialog,
    ModuleBlock,
    InfoDetail,
    richText,
    RowContent,
    ColContent
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      ruleVisible: false,
      AccumulationLayoutEnum,
      currentRow: {}
    }
  },
  computed: {
    hasHelpIcon() {
      return this.model.helpIcon.backgroundImage && this.model.helpIcon.backgroundImageShow
    },
    ruleDialogWidth() {
      return this.$store.getters.isMobile ? '320px' : '500px'
    }
  },
  methods: {
    onItemClick(data) {
      this.currentRow = data
      this.$refs.info.init()
    },
    handleShowRuleModal() {
      this.ruleVisible = true
    }
  }
}
</script>

<style lang="less">
.accumulation-rule-dialog {
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      .el-icon {
        font-weight: bold;
      }
    }
  }
  &.is-edit&.is-mobile {
    left: 20px;
  }
}
.activity-widget {
  .activity_desc {
    margin-top: 20px;
  }
}
.activity_content_desk {
  padding: 20px 0;
  .help-icon {
    max-width: 40px;
    max-height: 40px;
  }
}

.activity_content_mobile {
  padding: 10px;
  .activity-widget__title {
    padding: 0 11px;
    .help-icon {
      max-width: 30px;
      max-height: 30px;
    }
  }
  .activity-widget__describe {
    padding: 0 11px;
  }
}
</style>
